export const VehicleRepairConfig = {
  api: {},
  events: {
    name: 'vehicle-repair',
    // refresh-index-data
    refresh: `rid-vehicle-repair`,
    // slideover-right
    sorId: 'vehicle-repair',
    sorOpen: (id) => `sor-open-vehicle-repair-${id}`,
    sorClose: (id) => `sor-close-vehicle-repair-${id}`,
    sorToggle: (id) => `sor-toggle-vehicle-repair-${id}`,
    // editing-data
    editingData: 'edit-vehicle-repair-data',
    // viewing-data
    viewingData: 'view-vehicle-repair-data',
  },
}
